// FEAT-018 — GitHub Project 진행 현황의 표시 규칙.
// ProjectsPage(간트) 와 제품 상세의 관련 Projects 가 공유한다. 같은 프로젝트가
// 두 화면에서 다르게 읽히면 안 되므로 판정은 여기 한 곳에만 둔다.

// 진행 상태의 종류. '이슈 미등록' 을 '0% 진행' 과 분리하는 것이 핵심 —
// 전자는 관리 방식이 아직 적용되지 않은 것이고, 후자는 적용된 채 시작 전인 것이다.
export const PROGRESS_KIND = {
  OK: 'ok', // 항목이 있고 집계됨
  NO_ISSUES: 'no-issues', // GitHub Project 는 있으나 항목 0건
  NO_PROJECT: 'no-project', // 차터에 GitHub Project 링크 자체가 없음
  ERROR: 'error', // 링크는 있으나 조회 실패 (권한/네트워크)
};

export const PROGRESS_COLOR = {
  [PROGRESS_KIND.OK]: '#3fb950',
  [PROGRESS_KIND.NO_ISSUES]: '#d29922',
  [PROGRESS_KIND.NO_PROJECT]: '#8b949e',
  [PROGRESS_KIND.ERROR]: '#f85149',
};

// item: /api/projects/board 의 items[] 한 건.
export function readProgress(item) {
  const p = item?.progress;
  if (p && p.total > 0) {
    return {
      kind: PROGRESS_KIND.OK,
      percent: p.percent ?? 0,
      counts: p,
      label: `${p.percent ?? 0}%`,
      detail: `완료 ${p.done} · 진행 ${p.inProgress} · 할 일 ${p.todo}${p.other ? ` · 미분류 ${p.other}` : ''} / 전체 ${p.total}`,
    };
  }
  if (p && p.total === 0) {
    return {
      kind: PROGRESS_KIND.NO_ISSUES,
      percent: null,
      counts: p,
      label: '이슈 미등록',
      detail: 'GitHub Project 는 만들어졌으나 아직 등록된 이슈가 없습니다',
    };
  }
  if (!item?.githubProject) {
    return {
      kind: PROGRESS_KIND.NO_PROJECT,
      percent: null,
      counts: null,
      label: 'Project 없음',
      detail: item?.progressError || '차터에 GitHub Project 링크가 없습니다',
    };
  }
  return {
    kind: PROGRESS_KIND.ERROR,
    percent: null,
    counts: null,
    label: '조회 실패',
    detail: item?.progressError || 'GitHub Project 진행 현황을 읽지 못했습니다',
  };
}

// 제품 매핑 근거 표기. 어떤 근거로 이 제품에 붙었는지 드러내야
// 잘못 붙은 연결을 차터에서 고칠 수 있다.
export const PRODUCT_SOURCE_LABEL = {
  explicit: '📌 차터 명시',
  'super-repo': '🔗 제품 저장소',
  repo: '🔗 저장소 링크',
};

// 제품 미지정 프로젝트를 모으는 가상 키 — 화면에서 별도 그룹으로 드러낸다.
export const UNASSIGNED_PRODUCT = '__unassigned__';

// board items[] → 제품 id 별 프로젝트 목록. 한 프로젝트가 여러 제품에 걸리면 양쪽에 들어간다.
export function groupByProduct(items) {
  const map = new Map();
  for (const it of items) {
    const keys = it.products?.length ? it.products.map((p) => p.id) : [UNASSIGNED_PRODUCT];
    for (const k of keys) {
      if (!map.has(k)) map.set(k, []);
      map.get(k).push(it);
    }
  }
  return map;
}
